
import React from 'react';
import { Button } from '@/components/ui/button';
import { Loader2 } from 'lucide-react';

interface CheckoutButtonProps {
  onClick: () => void;
  isLoading: boolean;
}

const CheckoutButton: React.FC<CheckoutButtonProps> = ({ onClick, isLoading }) => {
  return (
    <Button 
      className="w-full" 
      size="lg" 
      onClick={onClick}
      disabled={isLoading}
    >
      {isLoading ? (
        <>
          <Loader2 className="mr-2 h-4 w-4 animate-spin" />
          Preparing Checkout...
        </>
      ) : (
        'Complete Subscription'
      )}
    </Button>
  );
};

export default CheckoutButton;
